import React from 'react'
import { Route, Switch } from 'react-router'
import VehicleEventsList from './VehicleEventsList'
import VehicleEventsEdit from './VehicleEventsEdit'

const VehicleEvents = props => (
    <Switch>
        <Route exact path={props.match.url} component={VehicleEventsList} />
        <Route exact path={`${props.match.url}/new`} component={VehicleEventsEdit} />
        <Route exact path={`${props.match.url}/:vehicleEventID`} component={VehicleEventsEdit} />
    </Switch>
)

export default VehicleEvents
